import { render, staticRenderFns } from "./CadastroCorretor.vue?vue&type=template&id=3add3ef2&scoped=true"
import script from "./CadastroCorretor.vue?vue&type=script&lang=js"
export * from "./CadastroCorretor.vue?vue&type=script&lang=js"
import style0 from "./CadastroCorretor.vue?vue&type=style&index=0&id=3add3ef2&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3add3ef2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Desenvolvimento\\EZZE\\Ezze.Corretor.Front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3add3ef2')) {
      api.createRecord('3add3ef2', component.options)
    } else {
      api.reload('3add3ef2', component.options)
    }
    module.hot.accept("./CadastroCorretor.vue?vue&type=template&id=3add3ef2&scoped=true", function () {
      api.rerender('3add3ef2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CadastroCorretor.vue"
export default component.exports